import { render, staticRenderFns } from "./AddAndEditWalletWithhold.vue?vue&type=template&id=09cc62f2&scoped=true"
import script from "./AddAndEditWalletWithhold.vue?vue&type=script&setup=true&lang=js"
export * from "./AddAndEditWalletWithhold.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AddAndEditWalletWithhold.vue?vue&type=style&index=0&id=09cc62f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09cc62f2",
  null
  
)

export default component.exports